import React from "react";

import { useFormikContext } from "formik";

import { Box, Divider, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { RadioOptions } from "../../RadioOptions";

export const PossuiCartao = ({ idTipoPendencia, scrollToField }) => {
  const { values, errors, touched } = useFormikContext();

  return (
    <Group
      border={
        ["22", "23"].includes(idTipoPendencia) ? "3px solid #4299E199" : ""
      }
      scrollToField={
        ["22", "23"].includes(idTipoPendencia) ? scrollToField : null
      }
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        CARTÃO NACIONAL DO SUS
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui Cartão Nacional do SUS?*"
        fieldName="possuiCartaoSus"
        errors={errors}
        touched={touched}
      />
      {values.possuiCartaoSus === "S" && (
        <Grid
          mt="15px"
          templateColumns="repeat(5, 1fr)"
          gap="25px"
          rowGap="20px"
        >
          <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
            <Box width={{ lg: "450.48px" }}>
              <CustomInputWField
                fieldName="numeroCartaoSus"
                label="Número do Cartão do SUS*"
                placeholder="Informe o Número do Cartão do SUS"
                whiteSpace={true}
              />
            </Box>
          </GridItem>
        </Grid>
      )}
    </Group>
  );
};
